import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, Radio, DatePicker } from 'antd';
import ButtonStyle from '../util/ButtonStyle';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import SearchClientPopup from "./SearchClientPopup";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import setup from '../setup';
registerLocale('ko', ko)

const { Option } = Select;
const { RangePicker } = DatePicker;

const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 9,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

const classConfig = {
    rules: [
      {
        type: 'array',
        required: true,
        message: '수강기간을 입력해 주세요!',
      },
    ],
};

function CouponPopup(props) {
    const [cid, setCid] = useState('');
    const [showSearch, setShowSearch] = useState(false);
    const [name, setName] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const data = useSelector(state => state.data);
    const [form] = Form.useForm();

    function toggleSearch() {
        setShowSearch(!showSearch)
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
        form.setFieldsValue({
            cid: cid
        });
    }

    function onInfoSubmit(name, cd) {
        setName(name);
        form.setFieldsValue({
            name: name,
            cd : cd
        });
    }

    const onFinish = (values) => {
        console.log(values);
        const { cid, cd, class_date } = values;
        let sdate = moment(class_date[0]).format('YYYY-MM-DD');
        let edate = moment(class_date[1]).format('YYYY-MM-DD');

        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/hg/create_coupon', {
                mcd : cd,
                cid: cid,
                sdate : sdate,
                edate : edate,
                ctype : 'w'
            })
            if(result.data.ret == 'Y'){
                alert('등록되었습니다');
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    };

    useEffect(()=>{
        setTitle("WEEKLY 쿠폰 추가");
        form.setFieldsValue({
            type : 'weekly'
        });
    },[]);

    return(
        <div className="popup weekly">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Form {...layout} form={form} onFinish={onFinish}>
            <Form.Item
                name="name"
                label="고객명"
                rules={[{ required: true, message: '고객명을 입력해 주세요.' }]}
            >
                <Input.Group>
                <Input.Search type="text" onSearch={toggleSearch} className="ant-input-readonly" readOnly value={name}/>
                </Input.Group>
            </Form.Item>
            <Form.Item
                name="cid"
                label="센터명"
                rules={[{ required: true, message: '센터를 선택해 주세요.' }]}
            >
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100"/>
            </Form.Item>
            <Form.Item name="type" label="종류"
                rules={[{ required: true, message: '종류를 선택해 주세요.' }]}
            >
                <Radio.Group>
                <Radio value="weekly">weekly</Radio>
                <Radio value="super" disabled>super</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name="class_date" label="수강기간" {...classConfig}>
                <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item name="cd" noStyle>
                <Input type="hidden" />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">추가</Button>
            </Form.Item>
            </Form>
            
            {showSearch ? 
            <SearchClientPopup
                closePopup={toggleSearch}
                onSubmit = {onInfoSubmit}
                onlyClient
            />
            : null
            }
            </div>
            </Draggable>
        </div>
    )
}

export default CouponPopup;
